import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { MultiAuctionService } from 'src/app/features/multi-auction-bidder/core/service/multi-auction.service';

@Component({
  selector: 'app-join-multi-room',
  templateUrl: './join-multi-room.component.html',
  styleUrls: ['./join-multi-room.component.css']
})
export class JoinMultiRoomComponent implements OnInit {

  loading =false;
  constructor(
    public dialogRef: MatDialogRef<JoinMultiRoomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _api:MultiAuctionService,
    public _config : ConfigService, 
    public socket: SocketService
  ) { }

  ngOnInit() {
  }

  join(){
 this.loading = true;
    this._api.joinAuction(this.data.id).subscribe({
      next : (data) =>{
        this.socket.socket.emit(`join`, this.data.id);
        this.loading = false;
        this._config.toastrService.success(data.message);
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

        this.loading = false;
      }
    })
  }
}
